import { render, staticRenderFns } from "./Summary.vue?vue&type=template&id=ef4d52d8&scoped=true"
import script from "./Summary.ts?vue&type=script&lang=ts&external"
export * from "./Summary.ts?vue&type=script&lang=ts&external"
import style0 from "./summary.scss?vue&type=style&index=0&id=ef4d52d8&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef4d52d8",
  null
  
)

export default component.exports